import React, { useState, useEffect } from "react";
import EventMap from './EventMap';
import LeftContainer from '../../components/MarsFamilyHome.jsx/LeftContainerHome';
import RightContainer from '../RightContainerHome';
import ListModal from '../../components/ListModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { GET_REGIONS } from "../ApiDetails.js";

export default function Vip2() {
  const [showModal, setShowModal] = useState(false);
  const [filteredEventDates, setFilteredEventDates] = useState([]);
  const [filters, setFilters] = useState({
    myEvents: true,
    otherFamilyEvents: true,
    needsFamilyMembers: true,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()+1);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [selectedYearPrev, setSelectedYearPrev] = useState(new Date().getFullYear()-1);
  const [regions, setRegions] = useState([]); // State to store regions
  const [selectedRegion, setSelectedRegion] = useState('');
  const toggleModal = () => setShowModal(!showModal);
 
  useEffect(() => {
    // Fetch regions from the API
    const fetchRegions = async () => {
      try {
        const response = await axios.get(GET_REGIONS);
        setRegions(response.data); // Assuming the API returns an array of regions
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };
 
    fetchRegions();
  }, []);

  const handleFilterChange = (event) => {
    const { id, checked } = event.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [id]: checked,
    }));
  };
  const firstName = localStorage.getItem('firstName');
  const lastName = localStorage.getItem('lastName');
  const handleYearChange = (date) => {
    setSelectedYear(date.getFullYear());
    setSelectedEndDate(date.getFullYear()+"-12-31");
    if (date.getFullYear()<selectedYearPrev) {
      setSelectedYearPrev(date.getFullYear());
      setSelectedDate(date.getFullYear()+"-01-01");
    }
  };
  const handleYearPrevChange = (date) => {
    setSelectedYearPrev(date.getFullYear());
    setSelectedDate(date.getFullYear()+"-01-01");
    if (selectedYear<date.getFullYear()) {
      setSelectedYear(date.getFullYear());
      setSelectedEndDate(date.getFullYear()+"-12-31");
    }
  };

  const handleRegionChange = (event) => {
    setSelectedRegion(event.target.value);
  };

   
  return (
    <div className="container-fluid">
      <div className="row m-2">
        <div className="col-md-3 mt-1 mb-3 bg-light rounded">
          <div className="p-2 text-blue bg-light">
            <div className="font-700" style={{ fontSize: 18 }}>
              <span style={{ color: "rgba(0, 215, 185, 1)" }}>Welcome</span>
              <br />
               {lastName}, {firstName}
            </div>
 
            <div className="input-group mt-2">
              <label htmlFor="searchInput" className="p-0 font-700 input-group-text-custom-search input-group-text input-group-text-custom">Search &nbsp;</label>
              <input
                type="text"
                className="form-control-custom-search form-control-custom rounded form-control"
                id="searchInput"
                placeholder="Type a keyword"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <FontAwesomeIcon
                    icon={faSearch}
                    className="search-icon-custom"
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: "pointer" }}
              />
            </div>

            <div className="mt-3 font-800 text-uppercase" style={{ fontSize: 14 }}>
              FILTERS
            </div>
            <div className='input-group'>
              <label htmlFor="regionSelect" className="p-0 font-700 input-group-text-custom-search input-group-text input-group-text-custom">Select Region</label>
              <select
                className="custom-select-form custom-select2 rounded-pill form-select rounded form-select"
                id="regionSelect"
                style={{ marginLeft: '10px' }}
                value={selectedRegion}
                onChange={handleRegionChange}
              >
                {regions.map((region, index) => (
                  <option key={index} value={region}>{region}</option>
                ))}
              </select>
            </div>
            <div className="mt-2 d-flex flex-column text-blue2" style={{ fontSize: 12 }}>
              <div className="align-items-center mb-2 d-flex">
                <input className="form-check-input-custom2 form-check-input" type="checkbox" id="myEvents" checked={filters.myEvents} onChange={handleFilterChange} />
                <span className="font-mars-centra">My Events</span>
                <div className="circle-container ms-auto">
                  <span className="circle8"></span>
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <input className="form-check-input-custom2 form-check-input" type="checkbox" id="otherFamilyEvents" checked={filters.otherFamilyEvents} onChange={handleFilterChange} />
                <span className="ml-2 font-mars-centra">Other Family Events</span>
                <div className="circle-container ms-auto">
                  <span className="circle9"></span>
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <input className="form-check-input-custom2 form-check-input" type="checkbox" id="needsFamilyMembers" checked={filters.needsFamilyMembers} onChange={handleFilterChange} />
                <span className="ml-2 font-mars-centra">Needs Family Members</span>
                <div className="circle-container ms-auto">
                  <span className="circle10"></span>
                </div>
              </div>
              <div className='input-group'>
                <label htmlFor="yearPickerPrev" className="p-0 font-700 input-group-text-custom-search input-group-text input-group-text-custom">Select Year</label>
&nbsp;&nbsp;&nbsp;
                <div style={{width:"20%"}}>
                    <DatePicker
                      selected={new Date(selectedYearPrev, 0, 1)}
                      onChange={handleYearPrevChange}
                      showYearPicker
                      dateFormat={`yyyy`}
                      className="form-control-custom-search form-control-custom rounded form-control"
                      id="yearPickerPrev" 
                      />
                </div>
&nbsp;&nbsp;&nbsp;to&nbsp;
                <div style={{width:"20%"}}>
                    <DatePicker
                      selected={new Date(selectedYear, 0, 1)}
                      onChange={handleYearChange}
                      showYearPicker
                      dateFormat={`yyyy`}
                      className="form-control-custom-search form-control-custom rounded form-control"
                      id="yearPicker"
                    />
                </div>
              </div>  
            </div>
          </div>
        </div>
        <div className="col-md-9 mt-1 mb-3 rounded">
          <EventMap filters={filters} selectedRegion={selectedRegion} selectedYear={selectedYear} selectedYearPrev={selectedYearPrev} />
        </div>
      </div>
 
      <div className="progress d-flex flex-column" style={{ backgroundColor: 'gainsboro', height: '100%' }}>
        <div className="row">
          <div className="col-md-8">
            <LeftContainer
              setFilteredEventDates={setFilteredEventDates}
              filters={filters}
              searchQuery={searchQuery}
              selectedYear={selectedYear} // Pass selectedYear as a prop
              selectedYearPrev={selectedYearPrev}
              setSelectedYearPrev={setSelectedYearPrev}
              setSelectedYear={setSelectedYear}
              selectedDate={selectedDate}
              selectedEndDate={selectedEndDate}
              setSelectedDate={setSelectedDate}
              setSelectedEndDate={setSelectedEndDate}
              selectedRegion={selectedRegion}
            />
          </div>
          <div className="col-md-4">
            <RightContainer eventDates={filteredEventDates} />
          </div>
        </div>
      </div>
 
      <ListModal showModal={showModal} toggleModal={toggleModal} />
    </div>
  );
}